'use client';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { useTranslations } from 'next-intl';
import Link from 'next/link';

interface SuccessMessageProps {
    message: string;
    title?: string;
    className?: string;
    actionText?: string;
    actionHref?: string;
}

/**
 * A reusable success message component with subtle styling
 */
export default function SuccessMessage({
    message,
    title,
    className,
    actionText,
    actionHref,
}: SuccessMessageProps) {
    const t = useTranslations('SuccessMessage');

    return (
        <Alert variant="success-subtle" className={className}>
            <AlertTitle className="font-medium text-green-800">
                {title || t('defaultTitle')}
            </AlertTitle>

            <AlertDescription className="text-green-700">
                {message}
                {actionText && actionHref && (
                    <>
                        {' '}
                        <Link
                            href={actionHref}
                            className="font-medium text-green-800 underline transition-colors hover:text-green-900"
                        >
                            {actionText}
                        </Link>
                    </>
                )}
            </AlertDescription>
        </Alert>
    );
}
